import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { CompraAnimalesService } from "../../../../generated/grpc/pesaje_ganaderia_pb";
import { grpcCompraAnimalesDatabase } from "../database/GrpcCompraAnimalesDatabase";
import { CompraAnimalesRequest } from "../request/CompraAnimalesRequest";
import { CompraAnimalesResponse } from "../response/CompraAnimalesResponse";
import { fx_aplicarCambiosMovimientoAsync } from "./aplicarCambiosMovimiento";
import { toCompraAnimalesResponse } from "./CompraAnimalesGrpcService";

/** Variante gRPC-Web de `CompraAnimalesSaveService` (ver ese archivo): mismo
 *  guardado crear-o-actualizar (`id` ausente = crear). `putOneAsync` deja la
 *  compra en `GrpcCompraAnimalesDatabase` -el `fincaId` viene en la respuesta
 *  del server, ver el comentario de `CompraAnimalesItem` en el proto- y
 *  `fx_aplicarCambiosMovimientoAsync` escribe los lotes y las compras que el
 *  server recalculó, que vienen en la misma respuesta (2026-10-08). */
export class CompraAnimalesSaveGrpcService
  implements ISaveService<CompraAnimalesRequest, CompraAnimalesResponse>
{
  async saveAsync(
    request: CompraAnimalesRequest,
  ): Promise<CompraAnimalesResponse> {
    const client = createClient(CompraAnimalesService, grpcTransportProvider.get());

    let respuesta;
    try {
      respuesta = await client.guardar({
        id: request.id ?? undefined,
        fincaId: request.fincaId,
        loteEntradaId: request.loteEntradaId,
        razaAnimalId: request.razaAnimalId,
        fechaCompra: request.fechaCompra,
        cantidadAnimalesCompra: request.cantidadAnimalesCompra,
        pesoPromedioEntrada: request.pesoPromedioEntrada,
        precioKg: request.precioKg,
        gdpEsperadoGr: request.gdpEsperadoGr ?? 0,
        pesoTargetSalida: request.pesoTargetSalida,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    const saved = respuesta.compra;
    if (!saved) {
      throw new Error("El servidor no devolvió la compra guardada.");
    }

    await grpcCompraAnimalesDatabase.putOneAsync(saved);
    await fx_aplicarCambiosMovimientoAsync(respuesta);
    return toCompraAnimalesResponse(saved);
  }
}
